export class Toggle {
  constructor(
    public state: boolean = false) {
  }
}
